import React, { useState, useContext } from "react";
import { MenuTitle, MenuDescription } from "../Toolbar";
import { IonIcon } from "@ionic/react";
import { closeCircleOutline } from "ionicons/icons";
import styled, { css, keyframes } from "styled-components";
import { trashOutline } from "ionicons/icons";
import { useOutletContext } from "react-router";
import {
  FROM_X_TO_Y_PROMOTION,
  SIMPLE_PROMOTION,
  TAKE_X_PAY_Y_PROMOTION,
  VAREJO_ATACADO_PROMOTION,
} from "../../CanvasViewer/EncarteConstants";
import { isCartazFormat, toDataURL } from "../../../../services/Utils";
import PremiumContentProtectiveLayer from "../../../sharable/PremiumContentProtectiveLayer";
import { ProductForm } from "../../../sharable/ProductForm";
import WorkspaceContext from "../../WorkspaceContext";
import { VarejoAtacadoModal } from "./ChoosePromotionOption/PromotionModals/VarejoAtacadoModal";
import { ChoosePromotionOption } from "./ChoosePromotionOption/ChoosePromotionOption";
import { FloatWindowStyles } from "./ChoosePromotionOption/PromotionModals/promotionModalShared.styles";
import { TakeXPayYModal } from "./ChoosePromotionOption/PromotionModals/TakeXPayYModal.jsx";
import { FromXToYModal } from "./ChoosePromotionOption/PromotionModals/FromXToYModal.jsx";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 8.4rem);
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
`;

const rotating = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

export const BoxImage = styled.div`
  span {
    color: #fff !important;
  }
  position: relative;
  grid-column: 1/3;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  background-color: #fff;
  color: black;
  align-items: center;
  justify-content: center;
  height: min-content;
  width: 100%;
  .loading-currentProductImages {
    animation: ${rotating} 1s linear infinite;
    color: #d97706;
    grid-column: 1/-1;
    display: inline-block;
  }
  .button {
    grid-column: 1/-1;
  }
  ${({ imagesCount }) => {
    const gridColumns = imagesCount < 4 ? imagesCount : 4;
    return css`
      grid-template-columns: repeat(${gridColumns}, 1fr);
    `;
  }}
`;

const ProdutosContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const pulse = keyframes`
  0% { transform: scale(1); color: #fff; }
  50% { transform: scale(1.12); color: #d97706; }
  100% { transform: scale(1); color: #fff; }
`;

const AddProductButton = styled.button`
  all: unset;
  width: calc(100% - 3px);
  padding: 1.2rem 0;
  min-height: 3rem;
  font-size: 1.7rem;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  cursor: pointer;
  gap: 0.8rem;
  border-radius: 5px;
  font-weight: bold;
  margin-bottom: 2.4rem;
  &:hover {
    background-color: #d97706;
    border-color: transparent;
    transition: background-color 300ms ease-in-out;
  }
  &.disable {
    position: relative;
    border: none;
    cursor: default;
    &:after {
      content: "";
      position: absolute;
      width: 100%;
      border: 1px solid #fff;
      top: 50%;
    }
  }
  &.disable:hover {
    background-color: transparent;
  }

  // Animation for the text

  &.disable {
    span {
      animation: none;
    }
  }
  span {
    animation: ${pulse} 1.8s infinite;
  }

  &:hover span {
    animation: none;
  }
`;

const AdvancedOptionsFloatWindow = styled.div`
  ${FloatWindowStyles};
  .promotion-select-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export default function InputProducts({ props }) {
  /*
  TODO:SEE IF IS POSSIBLE TO CREATE A CURRENT PRODUCT OBJECT CACHE INSTEAD OF 
  HAVING ONLY SOME PROPERTIES LIKE ID AND NAME
  */
  const {
    products,
    onProductsChange,
    maxProducts,
    onCreateNewProduct,
    styles,
  } = useContext(WorkspaceContext);
  const { isAccountPremium } = useOutletContext();
  const [currentProductImages, setCurrentProductImages] = useState([]);
  const [currentProductName, setCurrentProductName] = useState("");
  const [currentProductId, setCurrentProductId] = useState(0);
  const [downloadingProductImage, setDownloadingProductImage] = useState(false);
  const [wasNoImageFound, setNoImageFound] = useState(false);
  const [
    showAdvancedOptionsForCurrentProduct,
    setShowAdvancedOptionsForCurrentProduct,
  ] = useState(false);
  const [
    currentOpenedPromotionFloatWindow,
    setCurrentOpenedPromotionFloatWindow,
  ] = useState(undefined);

  const handleCurrentProductImageUpdate = (image) => {
    if (!image || !products) return;
    setDownloadingProductImage(true);
    const arr = products;

    if (image.url.includes("/resources/files")) {
      arr[currentProductId].displayUrl = image.displayUrl;
      arr[currentProductId].imageURL = image.url;
      onProductsChange([...arr]);
      setDownloadingProductImage(false);
    } else {
      toDataURL(image.url).then((displayUrl) => {
        if (displayUrl === "") {
          alert(
            "Não foi possível realizar o download dessa imagem, por favor, selecione outra.",
          );
          setCurrentProductImages(
            currentProductImages.filter((i) => i.url !== image.url),
          );
        }
        arr[currentProductId].displayUrl = displayUrl;
        arr[currentProductId].imageURL = image.url;
        onProductsChange([...arr]);
        setDownloadingProductImage(false);
      });
    }
  };

  const updateProductInfo = (id, info, value) => {
    const arr = [...products];
    arr.forEach((p, i) => {
      if (i == id) {
        p[info] = value;
      }
    });
    onProductsChange(arr);
  };

  const removeProductEl = (el) => {
    const id = Number(
      el.target.closest(".product").getAttribute("data-product-id"),
    );
    const arr = products.filter((p, i) => i != id);
    onProductsChange(arr);
  };

  const handlePromotionModalSave = (fields) => {
    Object.entries(fields).forEach(([key, value]) => {
      console.log(fields);
      updateProductInfo(currentProductId, key, value);
    });
  };

  const currentProduct = products?.[currentProductId];
  const shouldShowRemovePromotion =
    currentProduct && currentProduct.promotionType !== SIMPLE_PROMOTION;

  const promotionOptions = [
    {
      mode: TAKE_X_PAY_Y_PROMOTION,
      titleLines: ["Pague X,", "Leve Y"],
      previewImage: "images/promotion-take-x-pay-y-example.png",
    },
    {
      mode: FROM_X_TO_Y_PROMOTION,
      titleLines: ["De X,", "por Y"],
      previewImage: "images/promotion-from-x-to-y-example.png",
    },
    {
      mode: VAREJO_ATACADO_PROMOTION,
      titleLines: ["Varejo,", "Atacado"],
      previewImage: "images/promotion-varejo-atacado-example.png",
    },
  ];

  return (
    <Container>
      <div>
        {showAdvancedOptionsForCurrentProduct && (
          <AdvancedOptionsFloatWindow
            isAccountPremium={isAccountPremium}
            className="flex direction-column"
          >
            {!isAccountPremium && (
              <PremiumContentProtectiveLayer className="protective-layer" />
            )}
            <div
              className="icon-wrapper flex min-gap align close-advanced-fields"
              onClick={() => {
                setShowAdvancedOptionsForCurrentProduct(
                  !showAdvancedOptionsForCurrentProduct,
                );
              }}
            >
              {" "}
              <span>Fechar</span>
              <IonIcon icon={closeCircleOutline} className="icon" />
            </div>
            <span className="edit-product-span">
              Editando <strong>'{currentProductName}'</strong>
            </span>
            <div className="promotion-select-list">
              <h1>Promoções</h1>
              <div className="flex direction-column">
                {shouldShowRemovePromotion && (
                  <div
                    onClick={() => {
                      updateProductInfo(
                        currentProductId,
                        "promotionType",
                        SIMPLE_PROMOTION,
                      );
                    }}
                    className="icon-wrapper min-gap flex align justify"
                  >
                    <span>Remover</span>
                    <IonIcon icon={trashOutline} className="icon" />
                  </div>
                )}
                {promotionOptions.map((option) => (
                  <ChoosePromotionOption
                    key={option.mode}
                    titleLines={option.titleLines}
                    previewImage={option.previewImage}
                    mode={option.mode}
                    setOpenedMode={setCurrentOpenedPromotionFloatWindow}
                  />
                ))}
              </div>
            </div>
          </AdvancedOptionsFloatWindow>
        )}
        <TakeXPayYModal
          isOpen={currentOpenedPromotionFloatWindow === TAKE_X_PAY_Y_PROMOTION}
          products={products}
          currentProductId={currentProductId}
          currentProductName={currentProductName}
          isAccountPremium={isAccountPremium}
          onClose={() => setCurrentOpenedPromotionFloatWindow(undefined)}
          onSave={handlePromotionModalSave}
        />

        <FromXToYModal
          isOpen={currentOpenedPromotionFloatWindow === FROM_X_TO_Y_PROMOTION}
          products={products}
          currentProductId={currentProductId}
          currentProductName={currentProductName}
          isAccountPremium={isAccountPremium}
          onClose={() => setCurrentOpenedPromotionFloatWindow(undefined)}
          onSave={handlePromotionModalSave}
        />

        <VarejoAtacadoModal
          isOpen={
            currentOpenedPromotionFloatWindow === VAREJO_ATACADO_PROMOTION
          }
          products={products}
          currentProductId={currentProductId}
          currentProductName={currentProductName}
          isAccountPremium={isAccountPremium}
          onClose={() => setCurrentOpenedPromotionFloatWindow(undefined)}
          onSave={(fields) => {
            handlePromotionModalSave({
              ...fields,
              promotionType: VAREJO_ATACADO_PROMOTION,
            });
          }}
        />
      </div>
      {products && (
        <>
          <MenuDescription>
            Dica: Adicione os produtos que irão chamar atenção dos seus clientes
            e fazer eles comprarem de você.
          </MenuDescription>
          <MenuTitle>Produtos</MenuTitle>
          {
            <AddProductButton
              className={maxProducts <= products.length ? "disable" : ""}
              onClick={() => {
                if (maxProducts <= products.length) return;
                onCreateNewProduct();
              }}
            >
              <span className="attention">Adicionar novo produto + </span>
            </AddProductButton>
          }

          <ProdutosContainer>
            {products.map((prod, i) => {
              return (
                <ProductForm
                  currentProductId={currentProductId}
                  currentProductImages={currentProductImages}
                  currentProductName={currentProductName}
                  downloadingProductImage={downloadingProductImage}
                  handleCurrentProductImageUpdate={
                    handleCurrentProductImageUpdate
                  }
                  removeProduct={removeProductEl}
                  prod={prod}
                  setCurrentProductId={setCurrentProductId}
                  setCurrentProductImages={setCurrentProductImages}
                  setNoImageFound={setNoImageFound}
                  setCurrentProductName={setCurrentProductName}
                  updateProductInfo={updateProductInfo}
                  wasNoImageFound={wasNoImageFound}
                  productIndex={i}
                  setShowAdvancedOptionsForCurrentProduct={
                    setShowAdvancedOptionsForCurrentProduct
                  }
                  showAdvancedOptionsForCurrentProduct={
                    showAdvancedOptionsForCurrentProduct
                  }
                  showImageButtons={
                    isCartazFormat(styles.format) ? false : true
                  }
                />
              );
            })}
          </ProdutosContainer>
        </>
      )}
    </Container>
  );
}
